/**
 * @param {string} container
 * Closes the opened answer card (<detail> tag) once the user chooses another answer
 * prevent custom "focus ring" from flashing when the element is mouse clicked
 */
export default function handleDetailClosing(container) {

  container = document.querySelector(container);

  if(!container) {
    return;
  }

  const details = container.querySelectorAll('details');

  if (details.length) {
    details.forEach((targetDetail) => {
      targetDetail.addEventListener('mousedown', (e) => e.preventDefault());
      targetDetail.addEventListener('click', () => {
        details.forEach((detail) => {
          if (detail !== targetDetail) {
            detail.removeAttribute('open');
          }
        });
      });
    });
  }
}
